import SchemaFormAutoSubmit from "@/components/Schema/SchemaFormAutoSubmit";
import { PageHeader } from "@ant-design/pro-components";
import { Button, Card, message } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { createForm } from "@formily/core";
import { useRef, useMemo } from "react";
import { notify } from "@/components/common/Notification";

const PP_PropertyMaster = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const isEditMode = !!id;

  // 👇 Must match exactly with the schema name stored in ArchitectureOne backend
  const schemaName = "PP_PropertyMaster";

  const form = useMemo(() => createForm({}), []);
  const formRef = useRef<{ handleSave: () => Promise<void> }>(null);

  const handleSave = async () => {
    try {
      await formRef.current?.handleSave();
      message.success("Property Master saved successfully!");
    } catch (error) {
      notify.error("Failed to save Property Master.");
      console.error(error);
    }
  };

  return (
    <>
      <PageHeader
        title={isEditMode ? "Edit Property Master" : "Property Master"}
        onBack={() => navigate(-1)}
      />

      <Card className="mt-4 rounded-xl shadow-md">
        {/* Schema loader */}
        <SchemaFormAutoSubmit
          form={form}
          schemaName={schemaName}
          recordId={isEditMode ? id : undefined}
          ref={formRef}
        />

        <div className="mt-6 flex justify-end">
          <Button type="primary" onClick={handleSave}>
            {isEditMode ? "Update" : "Save"}
          </Button>
        </div>
      </Card>
    </>
  );
};

export default PP_PropertyMaster;
